import { createContext } from 'react';
export const VisiteContext = createContext(null);